module.exports = __webpack_public_path__ + "static/img/contact_logo3_h.e318af4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/contact_logo3_h.png
// module id = NMPY
// module chunks = 1